import { createUseStyles } from 'react-jss';
import { NavigationMenuToggle } from '../navigation/NavigationMenu';

const useStyles = createUseStyles({
    wrapper: {
        borderRadius: '50%',
        background: 'rgba(0, 0, 0, 0.3)',
        position: 'fixed',
        zIndex: 10,
        top: 6,
        left: 10,
        marginTop: 'var(--ion-safe-area-top)',
        display: 'flex',
        alignItems: 'center',
        height: 42,
        width: 42,
        justifyContent: 'center'
    }
});

export const HomePageMenu: React.FC = () => {
    const classes = useStyles();
    return (
        <div className={classes.wrapper}>
            <NavigationMenuToggle noAppHeader />
        </div>
    );
};
